import PropTypes from 'prop-types';
import useIsUserDeniedByRol from '../hooks/useIsUserDeniedByRol';

export function CensoredData({ roles = ['superadmin', 'support'], children }) {
  const isUserInCompany = useIsUserDeniedByRol(roles);
  if (isUserInCompany) return children;
  // check if children is string
  if (typeof children === 'string') return children.split('').map((txt) => (txt ? '*' : txt));
  if (Array.isArray(children)) return children.map(() => '****');
  return '....';
}

CensoredData.propTypes = {
  companyId: PropTypes.string,
  children: PropTypes.node
};

export default CensoredData;
